import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-41c3208f")

_pushScopeId("data-v-41c3208f")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Islamic Account (Swap Free)")
const _hoisted_2 = { class: "f-sm term c-title mt-12" }
const _hoisted_3 = { class: "d-f fill" }
const _hoisted_4 = { class: "flex-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_FormInput = _resolveComponent("FormInput")
  const _component_ThePasswordInput = _resolveComponent("ThePasswordInput")
  const _component_Form = _resolveComponent("Form")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Button = _resolveComponent("Button")
  const _component_FBLoginButton = _resolveComponent("FBLoginButton")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, { useFooter: "" }, {
    title: _withId(() => [
      _createVNode(_component_t, { path: "signupemail_2" })
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          class: "primary ml-10",
          progress: _ctx.progress,
          onClick: _ctx.submit
        }, {
          default: _withId(() => [
            _createVNode(_component_t, { path: "signinup_14" })
          ]),
          _: 1
        }, 8, ["progress", "onClick"]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_FBLoginButton)
        ])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_t, { custom: "" }, {
        default: _withId(({t}) => [
          _createVNode(_component_Form, {
            ref: "form",
            schema: _ctx.emailRegisterSchema,
            class: "py-16",
            onSubmit: _ctx.register
          }, {
            default: _withId(() => [
              _createVNode(_component_FormInput, {
                placeholder: t('signupemail_3'),
                class: "block",
                name: "email"
              }, null, 8, ["placeholder"]),
              _createVNode(_component_ThePasswordInput, {
                placeholder: t('signupemail_4'),
                class: "block"
              }, null, 8, ["placeholder"])
            ]),
            _: 2
          }, 1032, ["schema", "onSubmit"])
        ]),
        _: 1
      }),
      (_ctx.isIslamic)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "islamic mb-16 df-middle",
            onClick: _cache[1] || (_cache[1] = () => _ctx.islamicCheck = !_ctx.islamicCheck)
          }, [
            _createVNode("div", {
              class: ["checkbox br-sm mr-8", {'active': _ctx.islamicCheck}]
            }, null, 2),
            _createVNode(_component_t, {
              path: "signinup_24",
              class: "f-md"
            }, {
              default: _withId(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_t, { custom: "" }, {
        default: _withId(({td, t}) => [
          _createVNode("p", _hoisted_2, [
            _createTextVNode(_toDisplayString(t('signinup_10')) + " ", 1),
            _createVNode(_component_router_link, {
              to: "/common/link?url=/terms_of_use.html&title=Terms",
              class: "c-primary f-medium"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(t('signinup_11') || 'Term & Conditions'), 1)
              ]),
              _: 2
            }, 1024),
            _createTextVNode(" " + _toDisplayString(t('signinup_12')) + " ", 1),
            _createVNode(_component_router_link, {
              to: "/common/link?url=/privacy_policy.html&title=Policy",
              class: "c-primary f-medium"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(t('signinup_13') || 'Privacy Policy'), 1)
              ]),
              _: 2
            }, 1024)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})